export const EXTRA_SERVICE_PRICES = {
  airport_sign: 2000,
  tokyo_station_sign: 3500,
  odawara_station_sign: 2500,
  hotel_sign: 0,
  shinkansen_ticket: 3000,
  hiace_14_seat_upgrade: 10000,
  fuji_5th_station: 10000,
};

export const CHILD_SEAT_PRICE = 2000;

export const OVERTIME_RATES = {
  alphard: 5000,
  hiace: 7000,
  premium_hiace: 10000,
};

export const initialOrderEditForm = {
  user_id: "",
  user_email: "",
  customer_name: "",
  phone: "",
  customer_code: "",
  service_type: "transfer",
  departure_date: "",
  pickup_time: "",
  pickup_area: "",
  dropoff_area: "",
  pickup_terminal: "",
  dropoff_terminal: "",
  pickup_location: "",
  pickup_location_detail: "",
  destination: "",
  dropoff_location_detail: "",
  flight_number: "",
  passenger_count: 1,
  luggage_count: 0,
  child_seat_count: 0,
  infant_seat_count: 0,
  trip_details: "",
  dispatch_note: "",
  vehicle_type: "alphard",
  selected_hours: 5,
  end_location: "",
  end_location_in_base: true,
  end_location_other: "",
  price: "",
  payment_already_received: false,
  credit_card_payment: false,
};

export const initialExtraServices = {
  airport_sign: false,
  tokyo_station_sign: false,
  odawara_station_sign: false,
  hotel_sign: false,
  shinkansen_ticket: false,
  hiace_14_seat_upgrade: false,
  fuji_5th_station: false,
  parking_fee: false,
  other: false,
};

export const calculateAdminExtraServiceTotal = (
  selectedServices = {},
  parkingFee = "",
  vehicleType = "",
  extendedWaitingQuantity = 0,
) => Object.keys(selectedServices).reduce((total, key) => {
  if (!selectedServices[key]) return total;
  if (key === "hiace_14_seat_upgrade" && vehicleType !== "hiace") return total;
  if (key === "parking_fee") {
    return total + Math.max(0, Math.round(Number(parkingFee) || 0));
  }
  return total + (EXTRA_SERVICE_PRICES[key] || 0);
}, getExtendedWaitingUnitPrice(vehicleType) * Math.max(0, Math.min(6, Number(extendedWaitingQuantity) || 0)));

export const normalizeVehicleType = (vehicleType) => {
  if (vehicleType === "alpha") return "alphard";
  if (vehicleType === "luxury_hiace") return "premium_hiace";
  return vehicleType;
};

export const cleanNullableText = (value) => {
  return value && value !== "None" && value !== "null" ? value : "";
};

export const getEffectiveOrderPrice = (order) => {
  if (!order) return undefined;
  return order.overridden_total_price ?? order.price ?? order.total_price;
};

export const normalizeManualPriceForUpdate = (submittedPrice, currentOrder) => {
  if (submittedPrice === "" || submittedPrice === null || submittedPrice === undefined) {
    return undefined;
  }

  const parsedPrice = Number(submittedPrice);
  if (!Number.isFinite(parsedPrice)) {
    return undefined;
  }

  const currentPrice = Number(getEffectiveOrderPrice(currentOrder) || 0);
  return parsedPrice === currentPrice ? undefined : parsedPrice;
};
import { getExtendedWaitingUnitPrice } from "../../utils/extendedWaiting";
